import React, { useState, useEffect } from 'react';

import Button from '@mui/material/Button';
/* const TermsLink = props => <Link to="/static/privacy" {...props} />
const TermsLink = props => <Link to="/static/terms" {...props} /> */

import { either } from '../../lib/utils/utils';

import styles from '../css/LandingFooter.module.scss';
import withAlert from './withAlert';
import {
	postGetStaticInfo,
	postGetServerVar,
	postGetAppVersion
} from '../../postGetStatic';
import Tooltip from '@mui/material/Tooltip';
import { VERSION } from '../../VERSION';

const LandingFooter = withAlert(({ onOpenAlertDlg }) => {
	const [agreementStatus, setAgreementStatus] = useState({});
	const [appVersion, setAppVersion] = useState(undefined);

	useEffect(() => {
		postGetServerVar('agreements').then(
			either(console.log, s => setAgreementStatus(s))
		);

		postGetAppVersion().then(
			either(console.log, v => setAppVersion(v))
		);
	}, []);

	const onGetStatic = info => {
		postGetStaticInfo(info).then(
			either(console.log, data => {
				onOpenAlertDlg({
					message: data,
					title: '',
					okCallback: () => {}
				});
			})
		);
	};

	return (
		<div className={styles.wrap}>
			<div className={styles.mainMsgText}>
				{agreementStatus.terms ? (
					<Button onClick={() => onGetStatic('terms')}>
						Terms and Conditions
					</Button>
				) : null}
				{agreementStatus.privacy ? (
					<Button onClick={() => onGetStatic('privacy')}>
						Privacy
					</Button>
				) : null}
				{agreementStatus.refunds ? (
					<Button onClick={() => onGetStatic('refunds')}>
						Refunds
					</Button>
				) : null}
			</div>

			<div className={styles.cd}>
				CyberDev &copy;{' '}
				<Tooltip title={`Server: ${appVersion} Client: ${VERSION}`}>
					<span>{new Date().getFullYear()} v.{appVersion}</span>
				</Tooltip>
			</div>
		</div>
	);
});

export default LandingFooter;
